module.exports = __webpack_public_path__ + "img/hm_logo_white.811b751e.png";